import React from 'react';
import ProductHydroTable from './ProductHydroTable';

const ProductHydro = ({ refreshTrigger }) => (
  <ProductHydroTable refreshTrigger={refreshTrigger} />
);

export default ProductHydro;
